import { Badge } from '@bbpos/ui';
import type { Product } from '@bbpos/types';
import type { UserRole } from '@bbpos/types';

const MANAGER_ROLES: readonly UserRole[] = ['SUPER_ADMIN', 'ADMIN', 'MODERATOR', 'OWNER', 'MANAGER'];

export function isManagerOrAbove(role?: UserRole): boolean {
  return !!role && (MANAGER_ROLES as readonly string[]).includes(role);
}

/** Stock and Min Stock; a null minimum (left blank, C04) is never low. */
type StockFields = Pick<Product, 'stock_quantity'> & { low_stock_threshold: number | null };

export function getStockBadge(product: StockFields) {
  const qty = Number(product.stock_quantity);
  const threshold = Number(product.low_stock_threshold);
  // A till sale may take stock below zero (QA IS1-005); that is out of stock too.
  if (qty <= 0) {
    return <Badge variant="danger" size="sm">Out of Stock</Badge>;
  }
  if (qty > 0 && qty <= threshold) {
    return <Badge variant="warning" size="sm">Low Stock</Badge>;
  }
  return <Badge variant="success" size="sm">In Stock</Badge>;
}

export function isOutOfStock(product: Pick<Product, 'stock_quantity'>): boolean {
  return Number(product.stock_quantity) <= 0;
}

export function isLowStock(product: StockFields): boolean {
  const qty = Number(product.stock_quantity);
  return qty > 0 && qty <= Number(product.low_stock_threshold);
}
